import { ProtocolContentData } from "../../protocol";
export default class StressAndStabilityInPort extends ProtocolContentData {
    portName;
    draftForward;
    draftMidship;
    draftAft;
    draftMeasurementPositionForward;
    draftMeasurementPositionMidship;
    draftMeasurementPositionAft;
    waterDensity;
    gzCurve;
    rightingLeverGz;
    gm;
    shearForces;
    bending;
    torsion;
    loadlineZone;
    freeText;
    constructor(portName, draftForward, draftMidship, draftAft, draftMeasurementPositionForward, draftMeasurementPositionMidship, draftMeasurementPositionAft, waterDensity, gzCurve, rightingLeverGz, gm, shearForces, bending, torsion, loadlineZone, freeText) {
        super();
        this.portName = portName;
        this.draftForward = draftForward;
        this.draftMidship = draftMidship;
        this.draftAft = draftAft;
        this.draftMeasurementPositionForward = draftMeasurementPositionForward;
        this.draftMeasurementPositionMidship = draftMeasurementPositionMidship;
        this.draftMeasurementPositionAft = draftMeasurementPositionAft;
        this.waterDensity = waterDensity;
        this.gzCurve = gzCurve;
        this.rightingLeverGz = rightingLeverGz;
        this.gm = gm;
        this.shearForces = shearForces;
        this.bending = bending;
        this.torsion = torsion;
        this.loadlineZone = loadlineZone;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=StressAndStabilityInPort.js.map